import { render, staticRenderFns } from "./modal-warning-detail.vue?vue&type=template&id=aff69b54&"
import script from "./modal-warning-detail.vue?vue&type=script&lang=js&"
export * from "./modal-warning-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports